// Library methods
import { useContext, useMemo } from "react";

// MUI Components
import Grid from "@mui/material/Grid";

// Components
import EyeReport from "./EyeReport";

// Utilities
import { ReportEachSectionContext } from "../../../contexts/CommentContext";
import { ReportDataContext } from "../../../contexts/ReportDataContext";

const VisualFieldReport = ({ sectionName }) => {
  const { reportData } = useContext(ReportDataContext);
  const {
    sectionId,
    sectionId2,
    examReport,
    examReport2,
    eyeReport,
    eyeReport2,
    duration,
    duration2,
    comments,
    comments2,
    durationStartTime,
    durationStartTime2,
  } = reportData?.[sectionName] ?? {};

  const ReportSectionContent = useMemo(() => {
    return (
      <Grid container sx={{ display: "flex" }} columnSpacing={4}>
        {examReport && (
          <Grid item xs={12} lg={6} pt={4}>
            <ReportEachSectionContext.Provider
              value={{
                sectionId,
                examReport,
                eyeReport,
                durationStartTime,
                duration,
                comments,
              }}
            >
              <EyeReport />
            </ReportEachSectionContext.Provider>
          </Grid>
        )}
        {examReport2 && (
          <Grid item xs={12} lg={6} pt={4}>
            <ReportEachSectionContext.Provider
              value={{
                sectionId: sectionId2,
                examReport: examReport2,
                eyeReport: eyeReport2,
                durationStartTime: durationStartTime2,
                duration: duration2,
                comments: comments2,
              }}
            >
              <EyeReport />
            </ReportEachSectionContext.Provider>
          </Grid>
        )}
      </Grid>
    );
  }, [
    comments,
    comments2,
    duration,
    duration2,
    durationStartTime,
    durationStartTime2,
    examReport,
    examReport2,
    eyeReport,
    eyeReport2,
    sectionId,
    sectionId2,
  ]);

  return <>{ReportSectionContent}</>;
};

export default VisualFieldReport;
